import { Step } from "react-joyride";

const stageMapModalTourSteps: Step[] = [
  {
    target: ".tour-map-address-window",
    content:
      "Enter the address of your job. If the address is unknown, you may enter an address that is nearby, and adjust in a later step.",
    buttons: ["close"],
    overlayClickAction: false,
    dismissKeyAction: false,
  },
  {
    target: ".leaflet-custom-marker-icon",
    content:
      "Now your map has been focused on the designated job area. Here you may adjust the red pin on screen by dragging and dropping it to the exact location of your job.",
  },
  {
    target: ".tour-map-change-address",
    content: "Change the address here to move your Pin and view a new area in Maps.",
  },
  {
    target: ".tour-map-overwrite-address",
    content:
      "Typing here will change the address text shown on the proposal, but does not change the actual job site you've designated on the map. Used particularly when you needed to move a Pin to a location that doesn't have an address (new subdivision for example).",
  },
  {
    target: ".tour-map-confirm-address",
    content: "If the location looks good, click here to add it to your proposal and continue.",
  },
];

export default stageMapModalTourSteps;
